import React, { createContext, useMemo, useState } from 'react';

import { SiteConfigManager } from '@atlas/core';

export const LiveChatContext = createContext();

export const useLiveChatContextState = () => {
  const [isOpened, setIsOpened] = useState(false);

  const chatType = useMemo(
    () => SiteConfigManager.getConfig('config.config.support.live_chat.desktop.type'),
    [],
  );

  const toggleIsOpened = React.useCallback(() => {
    if (chatType && window.LiveChatWidget) {
      window.LiveChatWidget.call('maximize');
    } else if (chatType && window.Tawk_API) {
      window.Tawk_API.maximize();
    } else if (chatType && window.$respond) {
      window.$respond.do('chat:open');
    } else if (chatType && window.zE) {
      if (chatType === 'ZendeskWebWidget') {
        window.zE('webWidget', 'open');
        window.zE('webWidget', 'show');
      } else {
        window.zE('messenger', 'open');
        window.zE('messenger', 'show');
      }
    } else if (chatType && window.octadesk) {
      window.octadesk.chat.showApp();
    } else if (chatType === 'Infobip' && window.liveChat) {
      window.liveChat('show');
    } else {
      setIsOpened(val => !val);
    }
  }, [setIsOpened, chatType]);

  return {
    isOpened,
    setIsOpened,
    toggleIsOpened,
  };
};
